import styled, { css } from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';

export const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  ${media.smallOnly`
    justify-content: center;
  `}
  ${props =>
    props.$cssGrid &&
    css`
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: ${layout.measurements.spacingNormal};
      ${media.mediumDown`
        grid-template-columns: repeat(3, 1fr);
      `}
      ${media.smallOnly`
        grid-template-columns: repeat(2, 1fr);
      `}
    `}
`;
export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  padding-top: 10px;
  padding-bottom: 10px;
`;
export const ToggleContainer = styled.div.attrs({
  'data-test': 'ToggleContainer',
})`
  display: flex;
  align-items: center;
  justify-content: center;
`;
